import { takeEvery, takeLatest } from 'redux-saga/effects';
import apiCall from '../../utils/apiCall';
import {
  ADD_EVENT,
  DELETE_EVENT,
  DELETE_EVENT_IMAGE,
  EDIT_EVENT,
  GET_EVENT,
  GET_EVENTS,
  NOTIFY_EVENT,
  SYNC_EVENT_IMAGES,
  UPLOAD_EVENT_IMAGE,
  UPLOAD_EVENT_IMAGES_BATCH
} from '../constants';

const getEvents = apiCall({
  type: GET_EVENTS,
  method: 'GET',
  path: '/events'
});

const getEvent = apiCall({
  type: GET_EVENT,
  method: 'GET',
  path: ({ id }) => `/events/${id}`
});

const addEvent = apiCall({
  type: ADD_EVENT,
  method: 'POST',
  path: '/events',
  isFormData: true
});

const editEvent = apiCall({
  type: EDIT_EVENT,
  method: 'PUT',
  path: ({ id }) => `/events/${id}`
});

const deleteEvent = apiCall({
  type: DELETE_EVENT,
  method: 'DELETE',
  path: ({ id }) => `/events/${id}`
});

const notifyEvent = apiCall({
  type: NOTIFY_EVENT,
  method: 'POST',
  path: ({ id }) => `/events/${id}/notify`
});

const uploadEventImage = apiCall({
  type: UPLOAD_EVENT_IMAGE,
  method: 'PUT',
  path: ({ id, imageType }) => `/events/${id}/image/${imageType}`,
  isFormData: true
});

const deleteEventImage = apiCall({
  type: DELETE_EVENT_IMAGE,
  method: 'DELETE',
  path: ({ id, imageType }) => `/events/${id}/image/${imageType}`
});

const uploadEventImagesBatch = apiCall({
  type: UPLOAD_EVENT_IMAGES_BATCH,
  method: 'post',
  path: '/images/batch',
  isFile: true
});

const syncEventImages = apiCall({
  type: SYNC_EVENT_IMAGES,
  method: 'put',
  path: '/images/sync',
  isFile: true
});

export default function* eventsSaga() {
  yield takeLatest(GET_EVENTS, getEvents);
  yield takeLatest(GET_EVENT, getEvent);
  yield takeLatest(ADD_EVENT, addEvent);
  yield takeLatest(EDIT_EVENT, editEvent);
  yield takeLatest(DELETE_EVENT, deleteEvent);
  yield takeLatest(NOTIFY_EVENT, notifyEvent);
  yield takeEvery(UPLOAD_EVENT_IMAGE, uploadEventImage);
  yield takeEvery(DELETE_EVENT_IMAGE, deleteEventImage);
  yield takeLatest(UPLOAD_EVENT_IMAGES_BATCH, uploadEventImagesBatch);
  yield takeLatest(SYNC_EVENT_IMAGES, syncEventImages);
}
